import React, { useEffect } from "react";
import "./InfoModal.scoped.scss";
import Portal from "components/layout/Portal";

export interface IInfoModalProps {
  isOpen: boolean,
  showCloseButton?: boolean,
  header?: string | React.ReactNode,
  width?: string | number,
  maxHeight?: string | number,
  onCloseButtonClicked?(): void,
  top?: string | number,
  children: any,
}


const InfoModal: React.FC<IInfoModalProps> = (props) => {
  useEffect(() => {
    let pageOffset = window.pageYOffset;

    if (props.isOpen) {
      document.body.style.top = `-${pageOffset}px`;
      document.body.classList.add('has-open-modal');
    }

    return () => {
      document.body.classList.remove('has-open-modal');
      document.body.style.removeProperty('top');
      window.scrollTo(0, pageOffset || 0);
    };
  }, [props.isOpen]);

  if (!props.isOpen) {
    return null;
  }

  return (
    <Portal>
      <div className="fade"></div>
          <div className="modal" style={{ width: props.width, maxHeight: props.maxHeight, top: props.top }}>
        <div className="top">
          <span className="header">
            {props.header}
          </span>
          {props.showCloseButton &&
            <span className="close"
              onClick={props.onCloseButtonClicked}>x</span>
          }
        </div>
        <div className="middle">
          {props.children}
        </div>
      </div>
    </Portal>
  );
}

export default InfoModal;